module.exports = __webpack_public_path__ + "img/file.c756e88c.svg";